// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"1eab3b37","90":"1c95b678","110":"a353e4c4","171":"f3b1fdbe","729":"07e3cdc3","808":"e4bf00b3","910":"57cdc971","972":"d1c32989","975":"4190790c"}[chunkId] + ".chunk.js";
};